import { makeStyles } from '@material-ui/core';
import React from 'react';
import Tab from './Tab';

type TabsProps = {
  options: string[];
  selectedIndex: number;
  setSelectedIndex: Function;
};

const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  },
  option: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    textAlign: 'center',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    border: '1px solid white',
    color: 'white'
  }
});

const Tabs: React.FC<TabsProps> = ({
  options,
  selectedIndex,
  setSelectedIndex
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {options.map((option, i) => {
        return (
          <Tab
            key={`${option}-${i}`}
            tabsLength={options.length}
            selectedIndex={selectedIndex}
            tabIndex={i}
            option={option}
            setSelectedIndex={setSelectedIndex}
          />
        );
      })}
    </div>
  );
};

export default Tabs;
